type BmkAddedEvent = CustomEvent<{ contentId: string; contentType: string; type: string }>
type BmkRemovedEvent = CustomEvent<{ contentId: string; type: string }>
type BmkReadyEvent = CustomEvent<{ bookmarkedIds: string[] }>

export default class FollowBookmark {
	private followBookmark: HTMLElement | null

	constructor() {
		this.followBookmark = document.querySelector('.followBookmark')
		this.onAdded = this.onAdded.bind(this)
		this.onRemoved = this.onRemoved.bind(this)
		this.onReady = this.onReady.bind(this)
	}

	init() {
		if (!this.followBookmark) return
		this.addEvent()
	}

	addEvent() {
		window.addEventListener('bmk:added', this.onAdded as EventListener)
		window.addEventListener('bmk:removed', this.onRemoved as EventListener)
		window.addEventListener('bmk:ready', this.onReady as EventListener)
	}

	/**
	 * Sync aria-checked once Bookmarker has fetched the user's bookmark list
	 */
	onReady(event: BmkReadyEvent) {
		const contentId = this.followBookmark?.getAttribute('data-bmk-content-id') ?? ''
		const isFollowed = event.detail?.bookmarkedIds?.includes(contentId) ?? false
		this.setAriaChecked(isFollowed)
	}

	/**
	 * Fired by Bookmarker when a follow bookmark is added
	 */
	onAdded(event: BmkAddedEvent) {
		if (event.detail?.type === this.followBookmark?.getAttribute('data-bmk')) {
			this.setAriaChecked(true)
		}
	}

	/**
	 * Fired by Bookmarker when a follow bookmark is removed
	 */
	onRemoved(event: BmkRemovedEvent) {
		if (event.detail?.type === this.followBookmark?.getAttribute('data-bmk')) {
			this.setAriaChecked(false)
		}
	}

	private setAriaChecked(isChecked: boolean) {
		this.followBookmark?.setAttribute('aria-checked', String(isChecked))
	}
}
